import React, { useState, useEffect } from 'react';
import { Spinner } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import default_pic from '../../../assets/Default_pfp.svg.png';
import axios from 'axios';

const EmployeeDetail = () => {
    const token = localStorage.getItem("token");
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const [isExperience, setIsExperience] = useState(false);
    const [educationEdit, setEducationEdit] = useState(false);
    const [profilePicUrl, setProfilePicUrl] = useState('');
    const { state } = useLocation();
    const [wageEdit, setWageEdit] = useState(false);
    const [wageForm, setWageForm] = useState({
        basic: '',
        da: '',
        hra: '',
        other_allowance: '',
        leave_with_wages: ''
    });
    const [digilockerLoading, setDigilockerLoading] = useState(false);
    const [allEditMode, setAllEditMode] = useState(false);
    const [savingAll, setSavingAll] = useState(false);
    const [uploadingDoc, setUploadingDoc] = useState("");
    const [uploadingKycDoc, setUploadingKycDoc] = useState("");
    const [allEditForm, setAllEditForm] = useState({});
    const [qualificationsJson, setQualificationsJson] = useState("[]");
    const [experiencesJson, setExperiencesJson] = useState("[]");
    const formatEmployeeId = (employeeId) => employeeId ? `CMPL${employeeId}` : 'N/A';

    // Accept both employeeId and userId from navigation state to avoid null IDs.
    const userId = state?.employeeId || state?.userId;

    async function fetchingProfile() {
        try {
            setLoading(true);
            setError(null);

            // Prefer supervisor endpoint when available (GET /api/supervisor/employee/:id).
            let response;
            try {
                response = await axios.get(
                    `${process.env.REACT_APP_BACKEND_URL}/api/supervisor/employee/${userId}`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );
                if (response?.data?.employee) {
                    setUser(response.data.employee);
                    return;
                }
            } catch (innerErr) {
                // If supervisor token not allowed, fall back to establishment endpoint.
                if (innerErr?.response?.status !== 401 && innerErr?.response?.status !== 403) {
                    console.warn('Supervisor fetch failed, falling back:', innerErr);
                }
            }

            // Establishment endpoint (POST) for establishment role.
            response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/establishment/employee-detail`,
                { userId },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );
            setUser(response.data.currentUser);
            const u = response.data.currentUser;
            setWageForm({
                basic: u?.basic || u?.hired?.basic || '',
                da: u?.da || u?.hired?.da || '',
                hra: u?.hra || u?.hired?.hra || '',
                other_allowance: u?.other_allowance || u?.hired?.other_allowance || '',
                leave_with_wages: u?.leave_with_wages || u?.hired?.leave_with_wages || '',
            });
        } catch (err) {
            console.error('Error fetching profile:', err);
            setError('Failed to load employee details. Please try again later.');
            toast.error('Failed to load employee details');
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (!userId) {
            return;
        }
        fetchingProfile();
    }, [userId]);

    useEffect(() => {
        if (!user) return;

        setAllEditForm({
            full_Name: user?.full_Name || '',
            email: user?.email || '',
            contact: user?.contact || '',
            emergency_contact: user?.emergency_contact || '',
            aadhar_number: user?.aadhar_number || '',
            care_of: user?.care_of || '',
            dob: user?.dob || '',
            gender: user?.gender || '',
            house: user?.house || '',
            street: user?.street || '',
            landmark: user?.landmark || '',
            loc: user?.loc || '',
            subdist: user?.subdist || '',
            dist: user?.dist || '',
            state: user?.state || '',
            country: user?.country || '',
            zip: user?.zip || '',
            po: user?.po || '',
            vtc: user?.vtc || '',
            pan_name: user?.pan_name || '',
            pan_number: user?.pan_number || '',
            date_of_joining: user?.date_of_joining || '',
            basic: user?.basic || user?.hired?.basic || '',
            da: user?.da || user?.hired?.da || '',
            hra: user?.hra || user?.hired?.hra || '',
            other_allowance: user?.other_allowance || user?.hired?.other_allowance || '',
            leave_with_wages: user?.leave_with_wages || user?.hired?.leave_with_wages || '',
            uan_number: user?.uan_number || '',
            epf_number: user?.epf_number || '',
            esi_number: user?.esi_number || '',
            esic_number: user?.esic_number || '',
            status: user?.status || 'Active',
        });

        setQualificationsJson(JSON.stringify(user?.qualifications || [], null, 2));
        setExperiencesJson(JSON.stringify(user?.experiences || [], null, 2));
    }, [user]);

    if (!userId) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                <div className="text-center">
                    <h4 className="text-danger">Invalid Employee ID</h4>
                    <p>Please go back and try again</p>
                </div>
            </div>
        );
    }

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </div>
        );
    }

    if (error) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                <div className="text-center">
                    <h4 className="text-danger">{error}</h4>
                    <button className="btn btn-primary mt-3" onClick={() => navigate(-1)}>Go Back</button>
                </div>
            </div>
        );
    }

    if (!user) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                <div className="text-center">
                    <h4 className="text-danger">Employee not found</h4>
                    <button className="btn btn-primary mt-3" onClick={() => navigate(-1)}>Go Back</button>
                </div>
            </div>
        );
    }

    function addPan() {
        navigate('/establisment_dashboard/add_pan', { state: { userId } });
    }
    
    function addAccount() {
        navigate('/establisment_dashboard/add_account', { state: { userId } });
    }
    
    const handleWageChange = (e) => {
        const { name, value } = e.target;
        setWageForm((prev) => ({ ...prev, [name]: value }));
    };

    const saveWages = async () => {
        try {
            await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/establishment/save-wages`,
                { user_id: userId, ...wageForm },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            toast.success('Wages updated');
            setWageEdit(false);
            // refresh user to show latest
            fetchingProfile();
        } catch (err) {
            toast.error(err?.response?.data?.message || 'Failed to update wages');
        }
    };

    const initiateDigilockerKyc = async () => {
        try {
            setDigilockerLoading(true);
            const response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/supervisor/digilocker/initialize/${userId}`,
                {
                    redirect_url: `${window.location.origin}/auth/digilocker-callback`,
                    use_websdk: false // Use redirect mode instead of WebSDK
                },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            
            if (response.data.success && response.data.data.redirect_url) {
                // Redirect to DigiLocker SDK URL
                window.location.href = response.data.data.redirect_url;
            } else {
                toast.error(response.data.message || 'Failed to initialize DigiLocker');
            }
        } catch (error) {
            console.error('DigiLocker initialization error:', error);
            toast.error(error?.response?.data?.message || 'Failed to initialize DigiLocker KYC');
        } finally {
            setDigilockerLoading(false);
        }
    };

    const handleAllEditChange = (e) => {
        const { name, value } = e.target;
        setAllEditForm((prev) => ({ ...prev, [name]: value }));
    };

    const saveAllDetails = async () => {
        try {
            setSavingAll(true);
            let qualifications = [];
            let experiences = [];

            try {
                qualifications = qualificationsJson.trim() ? JSON.parse(qualificationsJson) : [];
            } catch (e) {
                toast.error("Invalid JSON in Qualifications");
                return;
            }

            try {
                experiences = experiencesJson.trim() ? JSON.parse(experiencesJson) : [];
            } catch (e) {
                toast.error("Invalid JSON in Experiences");
                return;
            }

            const response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/establishment/update-employee`,
                {
                    userId,
                    updates: allEditForm,
                    qualifications,
                    experiences,
                },
                { headers: { Authorization: `Bearer ${token}` } }
            );

            setUser(response?.data?.currentUser || user);
            setAllEditMode(false);
            toast.success("Employee details updated successfully");
        } catch (err) {
            toast.error(err?.response?.data?.message || "Failed to update employee details");
        } finally {
            setSavingAll(false);
        }
    };

    const uploadPfEsicDoc = async (field, file) => {
        if (!file) return;
        try {
            setUploadingDoc(field);
            const formData = new FormData();
            formData.append("user_id", userId);
            formData.append(field, file);

            await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/establishment/upload/${field}`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            toast.success(`${field.toUpperCase()} uploaded successfully`);
            fetchingProfile();
        } catch (err) {
            toast.error(err?.response?.data?.message || `Failed to upload ${field.toUpperCase()}`);
        } finally {
            setUploadingDoc("");
        }
    };

    const uploadKycDocument = async (endpoint, file, successLabel) => {
        if (!file) return;
        try {
            setUploadingKycDoc(endpoint);
            const formData = new FormData();
            formData.append("userId", userId);
            formData.append("image", file);

            await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/establishment/upload/${endpoint}`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "multipart/form-data",
                    },
                }
            );
            toast.success(`${successLabel} uploaded successfully`);
            fetchingProfile();
        } catch (err) {
            toast.error(err?.response?.data?.message || `Failed to upload ${successLabel}`);
        } finally {
            setUploadingKycDoc("");
        }
    };

    const uploadSignatureDocument = async (file) => {
        if (!file) return;
        try {
            setUploadingKycDoc("signature");
            const formData = new FormData();
            formData.append("signature", file);

            const response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/establishment/upload-signature`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "multipart/form-data",
                    },
                }
            );
            toast.success("Signature uploaded successfully");
            if (response?.data?.signature) {
                setUser((prev) => ({ ...prev, signature: response.data.signature }));
            } else {
                fetchingProfile();
            }
        } catch (err) {
            toast.error(err?.response?.data?.message || "Failed to upload Signature");
        } finally {
            setUploadingKycDoc("");
        }
    };

    const addressFields = [
        { label: 'House', value: user?.house },
        { label: 'Street', value: user?.street },
        { label: 'Landmark', value: user?.landmark },
        { label: 'Locality', value: user?.loc },
        { label: 'Sub District', value: user?.subdist },
        { label: 'District', value: user?.dist },
        { label: 'State', value: user?.state },
        { label: 'Country', value: user?.country },
        { label: 'Pincode', value: user?.zip },
    ];

    const docBaseUrl = process.env.REACT_APP_BACKEND_URL || "";
    const buildDocUrl = (value) => {
        if (!value) return null;
        const raw = String(value).trim();
        if (!raw) return null;
        if (/^https?:\/\//i.test(raw)) return raw;
        const normalizedPath = raw.startsWith("/uploads/")
            ? raw
            : `/uploads/${raw.replace(/^\/+/, "")}`;
        return `${docBaseUrl}${normalizedPath}`;
    };

    const documentList = [
        {
            label: 'PAN Card',
            number: user?.pan_number,
            url: buildDocUrl(user?.pan_image),
            hint: 'Pan document',
            uploadEndpoint: "pan-image",
            uploadLabel: "PAN Card",
        },
        {
            label: 'Aadhar Front',
            url: buildDocUrl(user?.aadhar_front_image),
            hint: 'Aadhar front',
            uploadEndpoint: "aadhar-front-image",
            uploadLabel: "Aadhaar Front",
        },
        {
            label: 'Aadhar Back',
            url: buildDocUrl(user?.aadhar_back_image),
            hint: 'Aadhar back',
            uploadEndpoint: "aadhar-back-image",
            uploadLabel: "Aadhaar Back",
        },
        {
            label: 'Account Proof',
            url: buildDocUrl(user?.account_image),
            hint: 'Bank proof',
            uploadEndpoint: "account-image",
            uploadLabel: "Account Proof",
        },
        { label: 'PF/ESIC File 1', url: buildDocUrl(user?.file1), hint: 'PF/ESIC supporting file 1' },
        { label: 'PF/ESIC File 2', url: buildDocUrl(user?.file2), hint: 'PF/ESIC supporting file 2' },
        {
            label: 'Signature',
            url: buildDocUrl(user?.signature),
            hint: 'Uploaded signature',
            uploadEndpoint: "signature",
            uploadLabel: "Signature",
        },
    ];

    return (
        <div id="screen">
            <div id="content">
                <div className='position-relative'>
                    <img 
                        id="user-avatar" 
                        src={user?.profilePic ? `${process.env.REACT_APP_BACKEND_URL}${user.profilePic}` : default_pic} 
                        alt="Avatar" 
                    />
                </div>
                <p id="user-name">{user?.full_Name || 'N/A'}</p>
                <p id="user-location">{user?.email || 'N/A'}</p>
            </div>
            
            <div className="profile-content-section d-flex gap-3 justify-content-center justify-content-sm-between flex-wrap px-0 px-sm-5">
                <div className="flex flex-col profile-content-box">
                    <dt>Employee ID</dt>
                    <dd>{formatEmployeeId(user?.employeeId)}</dd>
                </div>
                <div className="flex flex-col profile-content-box">
                    <dt>Aadhar No.</dt>
                    <dd>{user?.aadhar_number || 'N/A'}</dd>
                </div>
                <div className="flex flex-col profile-content-box">
                    <dt>Date Of Birth</dt>
                    <dd>{user?.dob || 'N/A'}</dd>
                </div>
                <div className="flex flex-col profile-content-box">
                    <dt>Gender</dt>
                    <dd>{user?.gender === 'M' ? 'Male' : user?.gender === 'F' ? 'Female' : (user?.gender || 'N/A')}</dd>
                </div>
                <div className="flex flex-col profile-content-box">
                    <dt>Phone Number</dt>
                    <dd>{user?.contact || 'N/A'}</dd>
                </div>
                <div className="flex flex-col profile-content-box">
                    <dt>State</dt>
                    <dd>{user?.state || 'N/A'}</dd>
                </div>
                <div className="flex flex-col profile-content-box">
                    <dt>Country</dt>
                    <dd>{user?.country || 'N/A'}</dd>
                </div>
            </div>

            <div className='id_sec'>
                <div className='pan_heading d-flex justify-content-between align-items-center'>
                    <h1>Edit All Candidate Details</h1>
                    <div className="d-flex gap-2">
                        {!allEditMode ? (
                            <button className="btn btn-primary btn-sm px-3 fw-semibold" onClick={() => setAllEditMode(true)}>
                                Edit All
                            </button>
                        ) : (
                            <>
                                <button className="btn btn-secondary btn-sm px-3 fw-semibold" onClick={() => setAllEditMode(false)}>
                                    Cancel
                                </button>
                                <button
                                    className="btn btn-success btn-sm px-3 fw-semibold"
                                    onClick={saveAllDetails}
                                    disabled={savingAll}
                                >
                                    {savingAll ? 'Saving...' : 'Save All'}
                                </button>
                            </>
                        )}
                    </div>
                </div>
                {allEditMode && (
                    <div className="profile-content-section d-flex gap-3 flex-wrap px-3 px-sm-5">
                        {[
                            ['full_Name', 'Full Name'], ['email', 'Email'], ['contact', 'Contact'],
                            ['emergency_contact', 'Emergency Contact'], ['aadhar_number', 'Aadhar Number'],
                            ['care_of', 'Father/Care Of'], ['dob', 'DOB'], ['gender', 'Gender'],
                            ['house', 'House'], ['street', 'Street'], ['landmark', 'Landmark'], ['loc', 'Locality'],
                            ['subdist', 'Sub District'], ['dist', 'District'], ['state', 'State'], ['country', 'Country'],
                            ['zip', 'Pincode'], ['po', 'PO'], ['vtc', 'VTC'], ['pan_name', 'PAN Name'],
                            ['pan_number', 'PAN Number'], ['date_of_joining', 'Date Of Joining'],
                            ['basic', 'Basic'], ['da', 'DA'], ['hra', 'HRA'], ['other_allowance', 'Other Allowance'],
                            ['leave_with_wages', 'Leave With Wages'], ['uan_number', 'UAN Number'],
                            ['epf_number', 'EPF Number'], ['esi_number', 'ESI Number'], ['esic_number', 'ESIC Number'], ['status', 'Status']
                        ].map(([name, label]) => (
                            <div key={name} className="flex flex-col profile-content-box" style={{ minWidth: '220px' }}>
                                <label className="form-label small">{label}</label>
                                <input
                                    className="form-control"
                                    name={name}
                                    value={allEditForm[name] || ''}
                                    onChange={handleAllEditChange}
                                />
                            </div>
                        ))}
                        <div className="w-100">
                            <label className="form-label small">Qualifications (JSON Array)</label>
                            <textarea
                                className="form-control"
                                rows={8}
                                value={qualificationsJson}
                                onChange={(e) => setQualificationsJson(e.target.value)}
                            />
                        </div>
                        <div className="w-100">
                            <label className="form-label small">Experiences (JSON Array)</label>
                            <textarea
                                className="form-control"
                                rows={8}
                                value={experiencesJson}
                                onChange={(e) => setExperiencesJson(e.target.value)}
                            />
                        </div>
                    </div>
                )}
            </div>

            <div className='id_sec'>
                <div className='pan_heading'>
                    <h1>KYC Verification</h1>
                    <div className="d-flex gap-2">
                        <button 
                            className={`btn ${user?.kyc ? 'btn-success' : 'btn-primary'} btn-sm px-3 fw-semibold`}
                            onClick={initiateDigilockerKyc}
                            disabled={digilockerLoading}
                        >
                            {digilockerLoading ? (
                                <>
                                    <Spinner animation="border" size="sm" className="me-2" />
                                    Processing...
                                </>
                            ) : user?.kyc ? (
                                'Re-verify KYC'
                            ) : (
                                'Verify KYC'
                            )}
                        </button>
                    </div>
                </div>
                <div className="profile-content-section d-flex gap-3 justify-content-center justify-content-sm-between flex-wrap px-0 px-sm-5">
                    <div className="flex flex-col profile-content-box">
                        <dt>KYC Status</dt>
                        <dd>
                            <span className={`badge ${user?.kyc ? 'bg-success' : 'bg-warning text-dark'}`}>
                                {user?.kyc ? 'Verified' : 'Pending'}
                            </span>
                        </dd>
                    </div>
                    <div className="flex flex-col profile-content-box">
                        <dt>Aadhaar Status</dt>
                        <dd>
                            <span className={`badge ${user?.aadhar_number ? 'bg-success' : 'bg-warning text-dark'}`}>
                                {user?.aadhar_number ? 'Uploaded' : 'Not Uploaded'}
                            </span>
                        </dd>
                    </div>
                    <div className="flex flex-col profile-content-box">
                        <dt>Verification Method</dt>
                        <dd>{user?.kyc ? 'DigiLocker SDK' : 'Not Verified'}</dd>
                    </div>
                </div>
                {user?.kyc && (
                    <div className="px-3 px-sm-5 mt-3">
                        <div className="alert alert-success">
                            <strong>KYC Completed!</strong> Employee has been successfully verified through DigiLocker SDK.
                        </div>
                    </div>
                )}
            </div>

            <div className='id_sec'>
                <div className='pan_heading'>
                    <h1>Address Details</h1>
                </div>
                <div className="profile-content-section px-3 px-sm-5">
                    <p className="mb-0 text-muted">
                        {addressFields
                            .map(({ value }) => value)
                            .filter(Boolean)
                            .join(", ") || "Not provided"}
                    </p>
                </div>
            </div>

            <div className='id_sec'>
                <div className='pan_heading'>
                    <h1>Uploaded Documents</h1>
                </div>
                <div className="profile-content-section d-flex gap-3 justify-content-center justify-content-sm-between flex-wrap px-3 px-sm-5">
                    {documentList.map((doc) => (
                        <div key={doc.label} className="flex flex-col profile-content-box" style={{ minWidth: '200px' }}>
                            <dt>{doc.label}</dt>
                            <dd className="d-flex flex-column">
                                {doc.number && <small className="text-muted mb-1">{doc.number}</small>}
                                {doc.url ? (
                                    <a
                                        className="btn btn-sm btn-outline-primary text-nowrap"
                                        href={doc.url}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        View {doc.hint}
                                    </a>
                                ) : (
                                    <span className="text-muted small">Not uploaded</span>
                                )}
                                {doc.uploadEndpoint && (
                                    <>
                                        <input
                                            type="file"
                                            accept=".jpg,.jpeg,.png,.pdf"
                                            className="form-control form-control-sm mt-2"
                                            onChange={(e) => {
                                                const file = e.target.files?.[0];
                                                if (doc.uploadEndpoint === "signature") {
                                                    uploadSignatureDocument(file);
                                                    return;
                                                }
                                                uploadKycDocument(
                                                    doc.uploadEndpoint,
                                                    file,
                                                    doc.uploadLabel
                                                );
                                            }}
                                            disabled={uploadingKycDoc === doc.uploadEndpoint}
                                        />
                                        <small className="text-muted mt-1">
                                            {uploadingKycDoc === doc.uploadEndpoint
                                                ? "Uploading..."
                                                : "JPG, PNG or PDF"}
                                        </small>
                                    </>
                                )}
                            </dd>
                        </div>
                    ))}
                </div>
                <div className="profile-content-section d-flex gap-3 flex-wrap px-3 px-sm-5 mt-3">
                    <div className="flex flex-col profile-content-box" style={{ minWidth: '280px' }}>
                        <dt>Upload PF/ESIC File 1</dt>
                        <input
                            type="file"
                            accept="application/pdf"
                            className="form-control mt-2"
                            onChange={(e) => uploadPfEsicDoc("file1", e.target.files?.[0])}
                            disabled={uploadingDoc === "file1"}
                        />
                        <small className="text-muted mt-1">
                            {uploadingDoc === "file1" ? "Uploading..." : "PDF only"}
                        </small>
                    </div>
                    <div className="flex flex-col profile-content-box" style={{ minWidth: '280px' }}>
                        <dt>Upload PF/ESIC File 2</dt>
                        <input
                            type="file"
                            accept="application/pdf"
                            className="form-control mt-2"
                            onChange={(e) => uploadPfEsicDoc("file2", e.target.files?.[0])}
                            disabled={uploadingDoc === "file2"}
                        />
                        <small className="text-muted mt-1">
                            {uploadingDoc === "file2" ? "Uploading..." : "PDF only"}
                        </small>
                    </div>
                </div>
            </div>

            <div className='id_sec'>
                <div className='pan_heading'>
                    <h1>Pan Card</h1>
                    <button onClick={addPan}>{user?.pan_added ? 'Change' : 'Add'}</button>
                </div>
                <div className="profile-content-section d-flex gap-3 justify-content-center justify-content-sm-between flex-wrap px-0 px-sm-5">
                    <div className="flex flex-col profile-content-box">
                        <dt>Pan No.</dt>
                        <dd>{user?.pan_number || 'N/A'}</dd>
                    </div>
                    <div className="flex flex-col profile-content-box">
                        <dt>Name</dt>
                        <dd>{user?.pan_name || 'N/A'}</dd>
                    </div>
                </div>
            </div>

            <div className='id_sec'>
                <div className='pan_heading'>
                    <h1>Account</h1>
                    <button onClick={addAccount}>{user?.account_added ? 'Change' : 'Add'}</button>
                </div>
                <div className="profile-content-section d-flex gap-3 justify-content-center justify-content-sm-between flex-wrap px-0 px-sm-5">
                    <div className="flex flex-col profile-content-box">
                        <dt>Account No.</dt>
                        <dd>{user?.account_number || 'N/A'}</dd>
                    </div>
                    <div className="flex flex-col profile-content-box">
                        <dt>Name</dt>
                        <dd>{user?.account_name || 'N/A'}</dd>
                    </div>
                    <div className="flex flex-col profile-content-box">
                        <dt>IFSC code</dt>
                        <dd>{user?.account_ifsc || 'N/A'}</dd>
                    </div>
                </div>
            </div>

            <div className='id_sec'>
                <div className='pan_heading'>
                    <h1>Education</h1>
                </div>
                <div className="profile-content-section d-flex gap-3 justify-content-center justify-content-sm-between flex-wrap px-3 px-sm-5">
                    {user?.qualifications?.map((qualification, index) => (
                        <div key={index} className='w-full d-flex gap-3 justify-content-between align-items-center'>
                            <div>
                                <h1 className='fs-6'>{qualification.institute}</h1>
                                <p>{`${qualification.degree}  • ${qualification.starting_month} ${qualification.starting_year} - ${qualification.ending_month} ${qualification.ending_year}  • Score: ${qualification.score}`}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div className='id_sec'>
                <div className='pan_heading'>
                    <h1>Experience</h1>
                </div>
                <div className="profile-content-section d-flex gap-3 justify-content-center justify-content-sm-between flex-wrap px-3 px-sm-5">
                    {user?.experiences?.map((experience, index) => (
                        <div key={index} className='w-full d-flex gap-3 justify-content-between align-items-center'>
                            <div>
                                <h1 className='fs-6'>{experience.company}</h1>
                                <p>{`${experience.role}  • ${experience.starting_month} ${experience.starting_year} - ${experience.ending_month} ${experience.ending_year}  • Score: ${experience.location}`}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div className='id_sec'>
                <div className='pan_heading d-flex justify-content-between align-items-center'>
                    <h1>Wages</h1>
                    <div className="d-flex gap-2">
                        <button className="btn btn-primary btn-sm px-3 fw-semibold" onClick={() => setWageEdit((p) => !p)}>
                            {wageEdit ? 'Cancel' : 'Update Wages'}
                        </button>
                    </div>
                </div>
                {!wageEdit ? (
                    <div className="profile-content-section d-flex gap-3 justify-content-center justify-content-sm-between flex-wrap px-0 px-sm-5">
                        <div className="flex flex-col profile-content-box">
                            <dt>Basic</dt>
                            <dd>{user?.basic || user?.hired?.basic || 'N/A'}</dd>
                        </div>
                        <div className="flex flex-col profile-content-box">
                            <dt>DA</dt>
                            <dd>{user?.da || user?.hired?.da || 'N/A'}</dd>
                        </div>
                        <div className="flex flex-col profile-content-box">
                            <dt>HRA</dt>
                            <dd>{user?.hra || user?.hired?.hra || 'N/A'}</dd>
                        </div>
                        <div className="flex flex-col profile-content-box">
                            <dt>Other Allowance</dt>
                            <dd>{user?.other_allowance || user?.hired?.other_allowance || 'N/A'}</dd>
                        </div>
                        <div className="flex flex-col profile-content-box">
                            <dt>Leave with Wages</dt>
                            <dd>{user?.leave_with_wages || user?.hired?.leave_with_wages || 'N/A'}</dd>
                        </div>
                    </div>
                ) : (
                    <div className="profile-content-section d-flex gap-3 flex-wrap px-0 px-sm-5">
                        {['basic', 'da', 'hra', 'other_allowance', 'leave_with_wages'].map((field) => (
                            <div key={field} className="flex flex-col profile-content-box" style={{ minWidth: '200px' }}>
                                <label className="form-label text-uppercase small">{field.replace(/_/g, ' ')}</label>
                                <input
                                    type="number"
                                    name={field}
                                    className="form-control"
                                    value={wageForm[field]}
                                    onChange={handleWageChange}
                                />
                            </div>
                        ))}
                        <div className="w-100 d-flex justify-content-end">
                            <button className="btn btn-success" onClick={saveWages}>Save Wages</button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default EmployeeDetail;
